import { memo, useEffect, useState } from 'preact/compat';

// TODO: TONCONNECT. Remove patch when package works with preact
import { TonConnectButton } from '@tonconnect/ui-react/packages/ui-react/lib/index.cjs';
import cn from 'clsx';

import { useIsTopBarVisible } from '@/app/hooks/use-is-top-bar-visible';

import { ShareButton } from '@/entities/buttons/share-button';
// import { PvpTopBar } from '@/entities/pvp-top-bar/ui/PvpTopBar';
import { XpIcon as XpLottie } from '@/entities/xp-icon/ui';

import { useFeatureFlag } from '@/shared/hooks/use-feature-flag';
import { useAppStateRaw, useGame } from '@/shared/stores/app-store/app-store';

import s from './index.module.scss';

export const TopBar = memo(() => {
  const game = useGame();
  const isVisible = useIsTopBarVisible();

  const isWeb = useAppStateRaw.getState().isWebMode;

  const { isTestUser } = useFeatureFlag();

  const [shouldRender, setShouldRender] = useState(isVisible);

  useEffect(() => {
    if (isVisible && !shouldRender) {
      setShouldRender(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible]);

  if (!shouldRender) return null;

  const isFullscreenGame = !!game?.flags.fullscreen;

  return (
    <div
      className={cn(
        s.container,
        isVisible ? s.enter : s.leave,
        isFullscreenGame && s['fullscreen-game']
      )}
      onAnimationEnd={() => {
        if (!isVisible) setShouldRender(false);
      }}
    >
      {/* {game?.fight ? (
        <PvpTopBar gameKey={game.key} fight={game.fight} />
      ) : (
        <>
          <div className={s.left}>
            <XpLottie />
            {isTestUser && <TonConnectButton className={s['ton-button']} />}
          </div>
          <div className={s.right}>{!isWeb && <ShareButton place="bar" />}</div>
        </>
      )} */}
      <>
        <div className={s.left}>
          <XpLottie />
          {isTestUser && <TonConnectButton className={s['ton-button']} />}
        </div>
        <div className={s.right}>{!isWeb && <ShareButton place="bar" />}</div>
      </>
    </div>
  );
});
